<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">My Voucher Tab</h5>
      <br />
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <b-button variant="primary" @click="showModalFormMyVoucherTab('create', '')">
            <img src="@/assets/create-new.svg" class="mr-2" alt />Add Tab
          </b-button>
        </b-col>
      </b-row>
      <br />
      <!-- <section v-if="table_error">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section> -->
      <b-table
        responsive
        show-empty
        hover
        ref="myVoucherTabTable"
        :items="getDataMyVoucherTab"
        :fields="types"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(title)="{ item }">
          <p class="mb-0">{{item.title}}</p>
        </template>
        <template v-slot:cell(voucher_tab)="{ item }">
          <p class="mb-0">{{item.voucher_tab}}</p>
        </template>
        <template v-slot:cell(notes)="{ item }">
          <p class="mb-0">{{item.notes}}</p>
        </template>
        <template v-slot:cell(voucher_order)="{ item }">
          <b-form-select
            class="w-75"
            v-model="item.voucher_order"
            name="voucher_order"
            v-validate="'required'"
            data-vv-as="Voucher Order"
            @change="changeVoucherOrder(item)"
          >
            <option
              v-for="data in option_voucher_order"
              :key="data.value"
              :value="data.value"
            >
              {{ data.text }}
            </option>
          </b-form-select>
        </template>
        <template v-slot:cell(action)="{item}">
          <b-row class="row">
            <div class="col-md-4">
              <b-link v-b-tooltip.hover title="Edit" class="text-dark" @click="showModalFormMyVoucherTab('edit', item.id)">
                <img src="@/assets/ic-edit.svg" class="mr-2" alt />
              </b-link>
            </div>
            <div class="col-md-4">
              <b-link v-if="!item.default_tab" v-b-tooltip.hover title="Delete" class="text-dark" @click="deleteMyVoucherTab(item.id, item.title)">
                <img src="@/assets/rectangle.svg" class="mr-2" alt />
              </b-link>
            </div>
            <div class="col-md-4">
              <b-row>
                <b-link
                  v-b-tooltip.hover
                  title="Up Order"
                  :class="{'order-link':item.order === 1}"
                  @click="orderField({id:item.id,change:'up'})"
                  class="text-primary"
                >
                  <i class="fas fa-arrow-up mr-2"></i>
                </b-link>
                <b-link
                  v-b-tooltip.hover
                  title="Down Order"
                  :class="{'order-link':item.is_last_order}"
                  @click="orderField({id:item.id,change:'down'})"
                  class="text-primary"
                >
                  <i class="fas fa-arrow-down"></i>
                </b-link>
              </b-row>
            </div>
          </b-row>
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" align="left" class="mx-auto px-0">
          <div v-if="totalRows == 0 || totalRows == null">
            Showing 0 Records
          </div>
          <div v-else>
            Showing {{ fromPage[currentPage - 1] }} to
            {{ toPage[currentPage - 1] }} of {{ totalRows }} Records
          </div>
        </b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal
      v-model="modalFormMyVoucherTabShow"
      size="sm"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop>
      <div class="container">
        <b-row>
          <b-col>
            <h4 class="font-weight-bold">{{editModal ? 'Edit' : 'Create' }} My Voucher Tab</h4>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold required"
              label="Title"
              label-for="input-1"
              style="font-size: 12px"
            >
              <input
                v-model="my_voucher_tab.title"
                v-validate="'required'"
                name="title"
                data-vv-as="Title"
                id="title"
                class="form-control"
                placeholder="Title"
              />
            <b-form-invalid-feedback id="input-title-feedback">{{
              veeErrors.first("title")
            }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold required"
              label="Voucher Tab"
              label-for="input-1"
              style="font-size: 12px"
            >
              <input
                v-model="my_voucher_tab.voucher_tab"
                v-validate="'required'"
                name="voucher_tab"
                data-vv-as="Voucher Tab"
                id="voucher_tab"
                class="form-control"
                placeholder="Voucher Tab"
              />
            <b-form-invalid-feedback id="input-voucher_tab-feedback">{{
              veeErrors.first("voucher_tab")
            }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Default Tab"
              label-for="input-1"
              style="font-size: 12px"
            >
              <b-form-select
                v-model="my_voucher_tab.default_tab"
                name="default_tab"
                v-validate="'required'"
                data-vv-as="Default Tab"
              >
                <option
                  v-for="data in option_default_tab"
                  :key="data.value"
                  :value="data.value"
                >
                  {{ data.text }}
                </option>
              </b-form-select>
              <p style="width: 100%; margin-top:.25rem; font-size: 80%;color: #e74a3b;">
                {{ veeErrors.first("default_tab") }}
              </p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Voucher Order"
              label-for="input-1"
              style="font-size: 12px"
            >
              <b-form-select
                v-model="my_voucher_tab.voucher_order"
                name="voucher_order"
                v-validate="'required'"
                data-vv-as="Voucher Order"
              >
                <option
                  v-for="data in option_voucher_order"
                  :key="data.value"
                  :value="data.value"
                >
                  {{ data.text }}
                </option>
              </b-form-select>
              <p style="width: 100%; margin-top:.25rem; font-size: 80%;color: #e74a3b;">
                {{ veeErrors.first("voucher_order") }}
              </p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Notes"
              label-for="input-1"
              style="font-size: 12px"
            >
              <input
                v-model="my_voucher_tab.notes"
                name="notes"
                data-vv-as="Notes"
                id="notes"
                class="form-control"
                placeholder="Notes"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-button
              variant="light"
              :disabled="loading_form_my_voucher_tab"
              @click="modalFormMyVoucherTabShow = !modalFormMyVoucherTabShow"
              class="text-primary"
              block
              size="lg"
              >Close</b-button
            >
          </b-col>
          <b-col>
            <b-button
              v-if="my_voucher_tab.id != ''"
              variant="primary"
              :disabled="loading_form_my_voucher_tab"
              @click="editMyVoucherTab()"
              block
              size="lg"
            >
              <b-spinner v-if="loading_form_my_voucher_tab" small label="Loading..."></b-spinner>
              <span v-else>Save</span>
            </b-button>
            <b-button
            v-else
              variant="primary"
              :disabled="loading_form_my_voucher_tab"
              @click="createMyVoucherTab()"
              block
              size="lg"
            >
              <b-spinner v-if="loading_form_my_voucher_tab" small label="Loading..."></b-spinner>
              <span v-else>Save</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      table_error: false,
      loading_my_voucher_tab: false,
      loading_form_my_voucher_tab: false,
      modalFormMyVoucherTabShow: false,
      editModal: false,
      my_voucher_tab: {
        id: "",
        title: "",
        voucher_tab: "",
        notes: "",
        voucher_order: "created_date",
        default_tab: false,
      },
      my_voucher_tabs: [],
      types: [
        {
          key: "title",
          label: "Tab Title",
          sortable: false,
          class: "text-left w-15"
        },
        {
          key: "voucher_tab",
          label: "Voucher Tab",
          sortable: false,
          class: "text-left w-15"
        },
        {
          key: "notes",
          label: "Notes",
          sortable: false,
          class: "text-left"
        },
        {
          key: "voucher_order",
          label: "Voucher Order",
          sortable: false,
          class: "text-left"
        },
        { key: "action", label: "Action", class: "text-left w-10" }
      ],
      fromPage: [],
      toPage: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
      filter: "",
      option_voucher_order: [
        {text: "Created Date", value: "created_date"},
        {text: "Expiry Date", value: "expiry_date"},
      ],
      option_default_tab: [
        {text: "Yes", value: true},
        {text: "No", value: false},
      ]
    }
  },
  methods: {
    getDataMyVoucherTab(ctx, callback) {
      this.loading_my_voucher_tab = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", false);
      this.$store
        .dispatch("MyVoucherTabModule/getMyVoucherTabWithPaging", formData)
        .then(response => {
          vm.totalRows = response.data.data.total_record;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPage; i++) {
            sum = i * vm.perPage;
            if (vm.totalRows <= sum) {
              from.push(sum - vm.perPage + 1);
              to.push(vm.totalRows - sum + sum);
            } else {
              from.push(sum - vm.perPage + 1);
              to.push(sum);
            }
          }
          this.fromPage = from;
          this.toPage = to;
          this.my_voucher_tabs = response.data.data.results || [];
          callback(response.data.data.results || []);
          this.loading_my_voucher_tab = false;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response ? error.response.data.message : "Failed get my voucher tab",
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading_my_voucher_tab = false;
          callback([]);
        });
      return null;
    },
    showModalFormMyVoucherTab(action, id) {
      this.my_voucher_tab = {
        id: "",
        title: "",
        voucher_tab: "",
        notes: "",
        voucher_order: "created_date",
        default_tab: false,
      };
      if (action == 'edit') {
        this.$store
        .dispatch("MyVoucherTabModule/getMyVoucherTab", id)
        .then(response => {
          this.my_voucher_tab = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });

        this.editModal = true;
      } else {
        this.editModal = false;
      }

      this.modalFormMyVoucherTabShow = !this.modalFormMyVoucherTabShow;
    },
    createMyVoucherTab() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading_form_my_voucher_tab = true;
          const formData = new FormData();
          formData.append("title", this.my_voucher_tab.title);
          formData.append("voucher_tab", this.my_voucher_tab.voucher_tab);
          formData.append("notes", this.my_voucher_tab.notes);
          formData.append("default_tab", this.my_voucher_tab.default_tab);
          formData.append("voucher_order", this.my_voucher_tab.voucher_order);
          this.$store
            .dispatch("MyVoucherTabModule/postMyVoucherTab", formData)
            .then((response) => {
              this.loading_form_my_voucher_tab = false;
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.modalFormMyVoucherTabShow = false;
              this.$refs.myVoucherTabTable.refresh();
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.data : "Failed store my voucher tab",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.loading_form_my_voucher_tab = false;
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    editMyVoucherTab() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading_form_my_voucher_tab = true;
          const formData = new FormData();
          formData.append("title", this.my_voucher_tab.title);
          formData.append("voucher_tab", this.my_voucher_tab.voucher_tab);
          formData.append("notes", this.my_voucher_tab.notes);
          formData.append("default_tab", this.my_voucher_tab.default_tab);
          formData.append("voucher_order", this.my_voucher_tab.voucher_order);
          this.$store
            .dispatch("MyVoucherTabModule/putMyVoucherTab", {
              id: this.my_voucher_tab.id,
              formData
            })
            .then((response) => {
              this.loading_form_my_voucher_tab = false;
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.modalFormMyVoucherTabShow = false;
              this.$refs.myVoucherTabTable.refresh();
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.data : "Failed store my voucher tab",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.loading_form_my_voucher_tab = false;
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    deleteMyVoucherTab(id, tabTitle) {
      this.$swal({
        text: `Are you sure want to delete ${tabTitle}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#6051a2",
        cancelButtonColor: "#f8f9fc",
        cancelButtonClass: "text-primary",
        confirmButtonText: "Delete",
        scrollbarPadding: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("MyVoucherTabModule/deleteMyVoucherTab", id)
            .then((response) => {
              this.$swal("Deleted!", "Your data has been deleted.", "success");
              this.$refs.myVoucherTabTable.refresh();
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.message : "Failed to delete",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
            });
        }
      });
    },
    orderField(order) {
      this.loading_form_my_voucher_tab = true;
      const orderData = {
        change_type: order.change,
      };
      this.$store
        .dispatch("MyVoucherTabModule/orderField", {
          id: order.id,
          orderData,
        })
        .then((response) => {
          this.$refs.myVoucherTabTable.refresh();
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading_form_my_voucher_tab = false;
        })
        .catch((error) => {
          this.loading_form_my_voucher_tab = false;
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response ? error.response.data.message : "Failed to change order",
            showConfirmButton: false,
            scrollbarPadding: false,
            timer: 1500,
          });
          console.log(error);
        });
    },
    changeVoucherOrder(item) {
      this.$swal({
        text: `Are you sure want to change voucher order?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#6051a2",
        cancelButtonColor: "#f8f9fc",
        cancelButtonClass: "text-primary",
        confirmButtonText: "Change",
        scrollbarPadding: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("MyVoucherTabModule/changeVoucherOrder", {
            id: item.id,
            voucher_order: item.voucher_order
          })
            .then((response) => {
              this.$swal("Changed!", "Your data has been changed.", "success");
              this.$refs.myVoucherTabTable.refresh();
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.message : "Failed to change voucher order",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.$refs.myVoucherTabTable.refresh();
            });
        } else {
          this.$refs.myVoucherTabTable.refresh();
        }
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  }
};
</script>